import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/13/thumb-landscape.jpg"

const Post13 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">FENDI／サンシャインショッパー／40 x35 x17cm</span>    
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          FENDI（フェンディ）は、1925年にイタリア・ローマで皮革・毛皮の専門店としてスタート。<br></br>世界中の女性が憧れるメゾンが、「正統派」の殻を破ったのは、あのカール・ラガーフェルドをデザイナーとして迎えた1965年のことでした！エナメル加工やステッチ使いなど、卓越した技術で革命的なデザインを生み出し、今もなお世界のトレンドをリードし続けています♪<br></br>ラクサスでは、最先端バッグからヴィンテージバッグまでお好きなバッグをレンタルすることができます。<br></br>その中でもマストアイテムであるフェンディ人気バッグを10選紹介します！
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ピーカブー</h2>
          <p>2009年に登場したフェンディのアイコンバッグ「ピーカブー」。ブランドからは毎年新モデルが発表され注目を集めています。シンプルなワンハンドルに、内側は２つのコンパートメントに分かれており、機能性も抜群。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/13/2.jpg" alt="" />
            </figure>        
        </div>
        <span className="text-center">FENDI／ミニピーカブー／23 x18 x11cm</span>    
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/3.jpg" alt="" />
            <span className="text-center">FENDI／ミニピーカブー／23 x19 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/4.jpg" alt="" />
            <span className="text-center">FENDI／ミニピーカブー／23 x18 x10cm</span> 
          </figure>          
        </div>
        <div className="text-max-width">
          <h2>サンシャイン</h2>
          <p>フェンディの大人気トートバッグ「サンシャイン」。荷物がたっぷり入るM/L/XLのサイズ展開に加え、2021年からはミニサイズの「サンシャイン ショッパー（SUNSHINE SHOPPER）」も登場。ストラップも付属しているので、斜めがけでコンパクトにお出かけできます。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/33.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/34.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">FENDI／サンシャインショッパー／35 x30 x14cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/35.jpg" alt="" />
            <span className="text-center">FENDI／サンシャインショッパー／40 x35 x17cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/36.jpg" alt="" />
            <span className="text-center">FENDI／サンシャインショッパースモール／13 x17 x5cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>バイザウェイ</h2>
          <p>ボストンバッグをモチーフにした横長のフォルムが特徴の「バイザウェイ」は、「ピーカブー」と並ぶブランドの定番バッグ。ハンドルにはアジャスターがついており、ボディ部分に収納することも可能。
          </p>
        </div> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/29.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/30.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">FENDI／バイザウェイスモール／19 x13 x9cm</span>              
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/31.jpg" alt="" />
            <span className="text-center">FENDI／バイザウェイスモール／20 x13 x10cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/32.jpg" alt="" />
            <span className="text-center">FENDI／バイザウェイミディアム／27 x18 x12cm</span> 
          </figure>       
        </div>
        <div className="text-max-width">
          <h2>モントレゾール</h2>
          <p>巾着型のコンパクトなシルエットが特徴の「モントレゾール」は、ファッショニスタの間でも人気のアイテム。代表的なFFモチーフの他、デザインやカラー展開も豊富なのでぜひチェックしてみて。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/21.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/22.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">FENDI／モントレゾール／12 x18 x10cm</span>              
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/23.jpg" alt="" />
            <span className="text-center">FENDI／モントレゾール／18 x25 x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/24.jpg" alt="" />
            <span className="text-center">FENDI／モントレゾール／12 x18 x10cm</span> 
          </figure>
        </div>    
        <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
          フェンディのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>バケット</h2>
          <p>バケットはSATCのキャリー・ブラッドショーが愛用していたことで、90年代に爆発的な人気を得たバッグです。そんなFENDI／フェンディを象徴する名品が2019年に復活しました。現在も人気継続中の大人の日常を格上げしてくれるバッグです！</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/13.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/14.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">FENDI／マンマバゲット／23 x15 x2cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/15.jpg" alt="" />
            <span className="text-center">FENDI／マンマバケット／25 x12 x3cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/16.jpg" alt="" />
            <span className="text-center">FENDI／マンマバケット／25 x16 x8cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
        <h2>イージー２ バゲット</h2>
        <p>ミニマルなフォルムにゴールドのFFモチーフが映える「イージー２ バゲット」。内側は３つのコンパートメントに仕切られ、外側にもポケットがついているので、小さめながら収納力は抜群！</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/17.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/18.jpg" alt="" />
          </figure>
        </div>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/19.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/20.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">FENDI／イージー2バゲット／19 x10 x5cm</span>   
        <div className="text-max-width">
          <h2>トロワジュール</h2>
          <p>シンプルで落ち着いたデザインの中に、細部までこだわり抜かれたステッチや配色が魅力♡マチがしっかりあるので、長財布やポーチも収納可能♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/6.jpg" alt="" />
          </figure>          
        </div>          
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/7.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/8.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">FENDI／プチトロワジュール／21 x17 x10cm</span>   
        <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
          フェンディのバッグを見る
        </Link>                     
        <div className="text-max-width">
          <h2>トゥージュール</h2>
          <p>「トゥージュール」は、台形ラインのフラットなフォルムが洗練された印象を演出。サイズは通常・プチサイズの２展開。デニムからワンピースまで、どんなスタイリングにも合わせやすい万能アイテムです。</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/25.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/26.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">FENDI／プチトゥージュール／26 x21 x11cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/27.jpg" alt="" />
            <span className="text-center">FENDI／プチトゥージュール／27 x20 x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/28.jpg" alt="" />
            <span className="text-center">FENDI／プチトゥージュール／26 x21 x12cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
          <h2>キャナイ</h2>
          <p> 2017年の春夏コレクションで発表された「キャナイ」。シルバーチェーンをスライドさせるだけで、ショルダーにもクロスボディになり、ハンドルは取り外しもできるスマートな仕様が魅力。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/37.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/38.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">FENDI／キャナイ／25 x18 x10cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/39.jpg" alt="" />
            <span className="text-center">FENDI／キャナイ／18 x14 x9cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/40.jpg" alt="" />
            <span className="text-center">FENDI／キャナイ／25 x18 x10cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>キャナイ エフ</h2>
          <p>「キャナイ エフ」は、かっちりとしたフォルムとフロントにあるゴールドの「F」がスタイリッシュな印象を演出。留め具はマグネットになっており、無駄のないシンプルなデザインが特徴。</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/10.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">FENDI／キャナイ エフ／25 x18 x9cm</span>              
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/11.jpg" alt="" />
            <span className="text-center">FENDI／キャナイ エフ／25 x18 x10cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/13/12.jpg" alt="" />
            <span className="text-center">FENDI／キャナイ／22 x13 x3cm</span> 
          </figure>
        </div>      
        <div className="text-two-cloumn">
          <h2>冒険心をくすぐる遊び心が<br className="pc"></br>詰まったフェンディの魅力</h2>
          <p>時には奇抜だと思えるフェンディのバッグがラグジュアリー感を失わないのは、ブランドの生い立ちと職人技が影響しているのかもしれませんね♡ラクサスでは魅力が詰まったフェンディのバッグを他にも色々と揃えております♪少しでも気になった方は、ぜひラクサスでフェンディのバッグ使ってみてくださいね！</p>
        </div>                                    
        <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
          フェンディのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post13

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 13}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
